import { useTranslation } from 'next-i18next';

import { FormSidebarItem } from '@/shared/components/layout/FormSidebar';

export const useAttributeGroups = () => {
  const { t } = useTranslation('entities/privateDocuments', { keyPrefix: 'group' });

  const privateDocumentGroups: FormSidebarItem[] = [
    { title: t('general'), icon: 'info' },
    { title: t('details'), icon: 'list-bullets' },
  ];

  return privateDocumentGroups;
};
